import type Competence from "constants/Competence";
import type { TransfertDto } from "models";

type CodeMetierNiveau = "COM" | "TER" | "PER";
type CodeMetierCompetence = "ALL" | "ASS" | "EAU" | "GCE" | "GEPU";
type CodeMetierAbbreviation = string;
export type CodeMetier = `${CodeMetierNiveau}-${CodeMetierCompetence}-${CodeMetierAbbreviation}`;

export interface Metier {
  code: CodeMetier;
  libelle: string;
  competence?: Competence;
  niveau: MetierNiveau;
  /** Notion spécifique à Collectivités, doit être renseignée avec un enrichissement */
  ordreAffichage?: number;
}

export enum MetierNiveau {
  commune = "Commune",
  perimetre = "Perimetre",
  territoire = "Territoire",
}

export type IsSdeaCompetentConditionFunction = (transferts?: Array<TransfertDto>) => boolean;

export interface MetierWithConditions extends Metier {
  isSdeaCompetentCondition: IsSdeaCompetentConditionFunction;
}

export interface MetierWithIsSdeaCompetent extends Metier {
  isSdeaCompetent: boolean;
}
